import React, { useEffect, useState } from "react";
import { useAuth } from "../../../AuthContext";
import axios from "axios";
import { imageUploadUrl } from "../../../common/constantVarialble";

/**
 * 텍스트 편집기 메뉴바
 * 
 * @returns void
 */

interface MenuBarProps {
    imageUrls: string[];
    setImageUrls: React.Dispatch<React.SetStateAction<string[]>>;
    imageUrlKeys: string[];
    setImageUrlKeys: React.Dispatch<React.SetStateAction<string[]>>;
    editor: any;
}

// 메뉴바 버튼 스타일을 동적으로 생성하는 함수
const getButtonStyle = (isActive: boolean) => {
    // isActive 매개변수를 기반으로 활성/비활성 상태에 따라 클래스를 동적으로 설정
    return `px-4 py-1 border border-slate-200 text-gray-200 rounded text-sm hover:bg-sky-200 hover:text-blue-500 ${isActive ? 'bg-cyan-400 text-gray-800 border-cyan-400' : ''}`;
};



const TextEditMenuBar: React.FC<MenuBarProps> = ({ imageUrls, setImageUrls, imageUrlKeys, setImageUrlKeys, editor }) => {
    //const { editor } = useCurrentEditor()
    const [loading, setLoading] = useState(false);
    // const [images, setImages] = useState([]); // Image Array
    // const [imageKeys, setImageKeys] = useState([]); // Image Key Array
    const { user } = useAuth(); // 포스팅 작성 User ID

    // 이미지 파일 Selected Event
    const fileSelected = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            await postImage(file);
        }
    };

    // const fileClick = (event: React.MouseEvent<HTMLInputElement>) => {
    //     alert('test');
    //     event.preventDefault(); // 기본 이벤트 중지
    //     event.target.value = "";
    // }


    // Post Image
    async function postImage(image: File) {
        const formData = new FormData();
        formData.append("file", image);
        //formData.append("description", "image upload");
        setLoading(true);


        const result = await axios.post(
            imageUploadUrl,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    uuid: user?.uid,
                }
            }
        );



        //console.log("========= Axios Post Result =========")
        //console.log(result);
        const imageUrl = result.data.data.image_url
        const imageKey = result.data.data.image_key

        setImageUrls([...imageUrls, imageUrl]);
        setImageUrlKeys([...imageUrlKeys, imageKey]);
        editor
            ?.chain()
            .focus()
            .setImage({ src: imageUrl })
            .run();
        //mainEditor?.commands.focus("end");
        setLoading(false);
    }


    if (!editor) {
        return null
    }

    return (
        <div className="flex flex-wrap  gap-2  p-2 rounded-t-md bg-slate-600">
            <button
                className={getButtonStyle(editor.isActive('bold'))}
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .toggleBold()
                        .run()
                }
            //className={editor.isActive('bold') ? 'text-red-600' : ''}
            >
                bold
            </button>
            <button
                className={getButtonStyle(editor.isActive('italic'))}
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .toggleItalic()
                        .run()
                }

            >
                italic
            </button>
            <button
                className={getButtonStyle(editor.isActive('strike'))}
                onClick={() => editor.chain().focus().toggleStrike().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .toggleStrike()
                        .run()
                }
            >
                strike
            </button>
            <button
                className={getButtonStyle(editor.isActive('code'))}
                onClick={() => editor.chain().focus().toggleCode().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .toggleCode()
                        .run()
                }
            >
                code
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().unsetAllMarks().run()}>
                clear marks
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().clearNodes().run()}>
                clear nodes
            </button>
            <button
                className={getButtonStyle(editor.isActive('code'))}
                onClick={() => editor.chain().focus().setParagraph().run()}
            >
                paragraph
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 1 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
            >
                h1
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 2 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
            >
                h2
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 3 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
            >
                h3
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 4 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
            >
                h4
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 5 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}
            >
                h5
            </button>
            <button
                className={getButtonStyle(editor.isActive('heading', { level: 6 }))}
                onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}
            >
                h6
            </button>
            <button
                className={getButtonStyle(editor.isActive('bulletList'))}
                onClick={() => editor.chain().focus().toggleBulletList().run()}
            >
                bullet list
            </button>
            <button
                className={getButtonStyle(editor.isActive('orderedList'))}
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
            >
                ordered list
            </button>
            <button
                className={getButtonStyle(editor.isActive('codeBlock'))}
                onClick={() => editor.chain().focus().toggleCodeBlock().run()}
            >
                code block
            </button>
            <button
                className={getButtonStyle(editor.isActive('blockquote'))}
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
            >
                blockquote
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().setHorizontalRule().run()}>
                horizontal rule
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().setHardBreak().run()}>
                hard break
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().undo().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .undo()
                        .run()
                }
            >
                undo
            </button>
            <button
                className={getButtonStyle(false)}
                onClick={() => editor.chain().focus().redo().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .redo()
                        .run()
                }
            >
                redo
            </button>
            <button
                className={getButtonStyle(editor.isActive('textStyle', { color: '#958DF1' }))}
                onClick={() => editor.chain().focus().setColor('#958DF1').run()}
            >
                purple
            </button>
            <label className={`${getButtonStyle(false)} hover:cursor-pointer hover:bg-sky-200 hover:text-blue-500`}>
                Image
                <input
                    className="hidden"
                    onChange={fileSelected}
                    type="file"
                    accept="image/*"
                />
            </label>
        </div>
    )
}

export { TextEditMenuBar };